<template>
  <TooltipProvider :delay-duration="100">
    <SidebarProvider class="!tw-w-auto">
      <div class="tw-flex tw-h-screen tw-w-full tw-bg-background tw-overflow-hidden">
        <div v-if="isDesktop" class="tw-flex-shrink-0">
          <DashboardSidebar />
        </div>

        <div class="tw-flex tw-flex-1 tw-flex-col tw-overflow-hidden">
          <DashboardMobileNav v-if="!isDesktop" />

          <div class="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-px-3 sm:tw-px-4 md:tw-px-7 tw-py-2">
            <main class="tw-flex-1 tw-p-1 sm:tw-p-2">
              <router-view v-slot="{ Component }">
                <Transition name="fade">
                  <component :is="Component" />
                </Transition>
              </router-view>
            </main>
          </div>
        </div>
      </div>
    </SidebarProvider>
  </TooltipProvider>
</template>

<script setup lang="ts">
import DashboardSidebar from "./components/DashboardSidebar.vue"
import DashboardMobileNav from "./components/DashboardMobileNav.vue"
import { SidebarProvider } from "@/components/ui/sidebar"
import { TooltipProvider } from "@/components/ui/tooltip"
import { useIsDesktop } from "@/components/ui/utils"

const { isDesktop } = useIsDesktop()
</script>
